import Thankyou from 'components/thankyou';
import ThankYouV1 from 'components/thankyouV1';
import { useContext } from 'react';
import { MPosContext } from 'utils/context';

const ThankYouPage = () => {
    const { permissions } = useContext(MPosContext);

    if (permissions.purchase_journey === 'v1') {
        return <ThankYouV1 />;
    }
    return <Thankyou />;
};

export default ThankYouPage;
